import actionType from "../actionTypes";
import _ from "lodash";
const reducerName = actionType.reduxUpdateSchoolsState;

export default {
  list: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "get",
          url: `/warboard/schools/list`,
        },
        actionType: actionType.schools.list,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },
  create: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "post",
          url: `/warboard/schools/create`,
        },
        actionType: actionType.schools.create,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },

  view: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "get",
          url: `/warboard/schools/view/${_.get(componentRequest, "params.id")}`,
        },
        actionType: actionType.schools.view,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },
  subscription: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "get",
          url: `/warboard/schools/subscription/${_.get(
            componentRequest,
            "params.id"
          )}`,
        },
        actionType: actionType.schools.subscription,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },

  update: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "post",
          url: `/warboard/schools/update`,
        },
        actionType: actionType.schools.update,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },

  updatephone: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "post",
          url: `/warboard/schools/update-phone`,
        },
        actionType: actionType.schools.updatePhone,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },

  updatephoto: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "post",
          url: `/warboard/schools/update-photo`,
        },
        actionType: actionType.schools.updatePhoto,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },

  getAiCoachConfig: (componentRequest) => {
    return (dispatch) => {
      const schoolId = _.get(componentRequest, "params.schoolId");
      const requestOptions = {
        axiosParams: {
          method: "get",
          url: `/warboard/schools/${schoolId}/ai-coach-config`,
        },
        actionType: actionType.schools.getAiCoachConfig,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },

  saveAiCoachConfig: (componentRequest) => {
    return (dispatch) => {
      const schoolId = _.get(componentRequest, "params.schoolId");
      const requestOptions = {
        axiosParams: {
          method: "post",
          url: `/warboard/schools/${schoolId}/ai-coach-config`,
          data: _.get(componentRequest, "body", {}),
        },
        actionType: actionType.schools.saveAiCoachConfig,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },

  addfeaturedphoto: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "post",
          url: `/warboard/schools/add-featured-photo`,
        },
        actionType: actionType.schools.addfeaturedphoto,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },
  send_invoice: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "post",
          url: `/warboard/schools/send-invoice`,
        },
        actionType: actionType.schools.addfeaturedphoto,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },
  subscriptionHistory: (componentRequest) => {
    return (dispatch) => {
      const requestOptions = {
        axiosParams: {
          method: "get",
          url: `/warboard/schools/subscription-history/${_.get(
            componentRequest,
            "params.id"
          )}`,
        },
        actionType: actionType.schools.subscriptionHistory,
        reducerName,
        dispatch,
        componentRequest,
      };
      global.api.requestAPI(requestOptions);
    };
  },
};
